<template>
	<div>
		<h1>Environnement</h1>

		<b-input v-model="env.name"></b-input>
		<br />
		<b-button @click="update">Mettre à jour</b-button>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";

	export default {
		name: "env",
		data() {
			return {
				env: { name: "" },
				id: this.$route.params.id,
			};
		},
		methods: {
			update: async function () {
				this.env.uid = this.id;
				await client.put(null, null, null, null, this.env);
			},
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.env) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			if (!this.client.details) this.client.details = {};

			if (!this.client.details.env) this.client.details.env = {};

			var keys = Object.keys(this.client.details.env);
			for (var i = 0; i < keys.length; i++) {
				if (keys[i] == this.id) {
					this.env = this.client.details.env[keys[i]];
					this.env.uid = keys[i];
				}
			}
		},
	};
</script>

<style></style>
